"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.EnqueueActionsController = void 0;
const value_observer_1 = require("@dqm/value-observer");
const react_1 = __importStar(require("react"));
function getCurrentActions(provider, defaultValue = []) {
    if (provider.getStatus() === value_observer_1.ValueStatus.Ok) {
        return provider.getValue();
    }
    return defaultValue;
}
const EnqueueActionsController = ({ children, valueService, }) => {
    const enqueueActionsProvider = valueService.getProvider("enqueue-actions");
    const currentActions = getCurrentActions(enqueueActionsProvider);
    const [status, setStatus] = (0, react_1.useState)(enqueueActionsProvider.getStatus());
    const [actions, setActions] = (0, react_1.useState)(currentActions);
    (0, react_1.useEffect)(() => {
        const unregister = valueService.registerListener("enqueue-actions", (provider) => {
            setStatus(provider.getStatus());
            setActions(getCurrentActions(provider));
        });
        return () => {
            unregister();
        };
    }, [valueService]);
    if (typeof children !== "function") {
        return null;
    }
    return react_1.default.createElement(react_1.default.Fragment, null, children({ status, actions }));
};
exports.EnqueueActionsController = EnqueueActionsController;
//# sourceMappingURL=EnqueueActionsController.js.map